import { defineComponent as v, ref as h, inject as b, onMounted as k, openBlock as m, createElementBlock as u, normalizeClass as y, unref as r, createVNode as x, withCtx as C, renderSlot as S, createCommentVNode as n, toDisplayString as g } from "vue";
import { ECheckboxBorderVariants as s } from "./novoui-vuejs47.js";
import B from "./novoui-vuejs26.js";
import "./novoui-vuejs71.js";
import "./novoui-vuejs72.js";
import "./novoui-vuejs3.js";
import "./novoui-vuejs4.js";
import "./novoui-vuejs5.js";
import "./novoui-vuejs6.js";
import "./novoui-vuejs7.js";
import "./novoui-vuejs79.js";
import "./novoui-vuejs80.js";
import "./novoui-vuejs9.js";
import "./novoui-vuejs10.js";
import "./novoui-vuejs41.js";
import "./novoui-vuejs12.js";
import "./novoui-vuejs13.js";
import "./novoui-vuejs14.js";
import "./novoui-vuejs15.js";
import "./novoui-vuejs16.js";
import "./novoui-vuejs18.js";
import "./novoui-vuejs19.js";
import "./novoui-vuejs20.js";
import "./novoui-vuejs21.js";
import "./novoui-vuejs22.js";
import "./novoui-vuejs23.js";
import "./novoui-vuejs25.js";
import "./novoui-vuejs27.js";
import "./novoui-vuejs29.js";
import "./novoui-vuejs30.js";
import "./novoui-vuejs31.js";
import "./novoui-vuejs32.js";
import "./novoui-vuejs33.js";
import "./novoui-vuejs36.js";
import "./novoui-vuejs110.js";
import "./novoui-vuejs39.js";
import "./novoui-vuejs40.js";
import { CheckboxGroupSymbol as V, CheckboxSizes as q } from "./novoui-vuejs52.js";
const N = {
  key: 0,
  class: "touch-area-assistive-text"
}, ce = /* @__PURE__ */ v({
  __name: "NCheckboxBorder",
  props: {
    /**
     * The text displayed under the checkbox.
     */
    assistiveText: {
      type: String,
      default: "",
      required: !1
    },
    /**
     * The html attribute `name` of the checkbox element within.
     */
    name: {
      type: String,
      default: "",
      required: !1
    },
    /**
     * Conveys the error state of checkbox and label.
     */
    error: {
      type: Boolean,
      default: !1,
      required: !1
    },
    /**
     * Disables the checkbox within.
     */
    disabled: {
      type: Boolean,
      default: !1,
      required: !1
    },
    /**
     * The value of the selected checkbox.
     */
    modelValue: {
      type: [String, Number, Boolean, Array],
      required: !1,
      default: void 0
    },
    /**
     * The html attribute `value` of the checkbox.
     */
    value: {
      type: [String, Number, Boolean],
      required: !1,
      default: void 0
    },
    /**
     * Controls whether the checkbox is in an indeterminate state. This is visual only.
     */
    indeterminate: {
      type: Boolean,
      default: !1,
      required: !1
    },
    /**
     * The style variant of the touch area.
     */
    variant: {
      type: String,
      required: !1,
      default: s.fill
    },
    /**
     * Renders the checkbox already checked.
     */
    checked: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["update:model-value"],
  setup(t, { emit: c }) {
    const i = t, e = h(i.modelValue), o = b(V, {});
    k(() => {
      i.checked && (e.value = !0);
    });
    function f(a) {
      var l;
      ((l = a.target) == null ? void 0 : l.nodeName) !== "INPUT" && (e.value = !e.value, d("update:model-value", e.value), a.preventDefault(), a.stopPropagation(), e.value && i.modelValue && (e.value = i.modelValue));
    }
    const d = c;
    function p(a) {
      d("update:model-value", a), e.value = !e.value, e.value && i.modelValue && (e.value = i.modelValue);
    }
    return (a, l) => (m(), u("div", {
      class: y(["touch-area", {
        "touch-area-outline": t.variant === r(s).outline,
        "touch-area-invalid": t.error || r(o).error,
        "touch-area-selected": e.value,
        "touch-area-disabled": t.disabled || r(o).disabled,
        "touch-area-indeterminate": e.value && t.indeterminate
      }]),
      onClick: f,
      "tab-index": 0
    }, [
      x(B, {
        size: r(q).large,
        name: t.name || r(o).name,
        error: t.error || r(o).error,
        disabled: t.disabled || r(o).disabled,
        "model-value": e.value,
        value: t.value,
        indeterminate: t.indeterminate && !!e.value,
        checked: e.value,
        "onUpdate:modelValue": p
      }, {
        default: C(() => [
          a.$slots.default ? S(a.$slots, "default", { key: 0 }) : n("", !0)
        ]),
        _: 3
      }, 8, ["size", "name", "error", "disabled", "model-value", "value", "indeterminate", "checked"]),
      t.assistiveText && t.assistiveText.trim() ? (m(), u("span", N, g(t.assistiveText), 1)) : n("", !0)
    ], 2));
  }
});
export {
  ce as default
};
